'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assignmentV2MessageReceived = assignmentV2MessageReceived;

var _getAssigneeIdForAssignmentMessage = require('conversations-schema/operators/assignment-message/getAssigneeIdForAssignmentMessage');

var _getters = require('conversations-schema/operators/assignment-message/getters');

var _findResponderByIdFromList = require('conversations-schema/responders/operators/findResponderByIdFromList');

var _fetchAgentResponder = require('../responders/actions/fetchAgentResponder');

var _getAllAgentResponders = require('../responders/selectors/getAllAgentResponders');

var _getSessionId = require('../selectors/widgetDataSelectors/getSessionId');

var _defaultMessageReceived = require('./defaultMessageReceived');

function assignmentV2MessageReceived(message, channel, threadId) {
  return function (dispatch, getState) {
    var assignedAgentId = (0, _getAssigneeIdForAssignmentMessage.getAssigneeIdForAssignmentMessage)(message);
    var responders = (0, _getAllAgentResponders.getAllAgentResponders)(getState());
    var newlyAssignedResponder = (0, _findResponderByIdFromList.findResponderByIdFromList)({
      responders: responders,
      responderId: assignedAgentId
    });

    var shouldFetchResponder = assignedAgentId && !newlyAssignedResponder;

    if (shouldFetchResponder) {
      dispatch((0, _fetchAgentResponder.fetchAgentResponder)({
        senderId: assignedAgentId,
        agentType: (0, _getters.getAssignedAgentType)(message),
        sessionId: (0, _getSessionId.getSessionId)(getState())
      }));
    }

    dispatch((0, _defaultMessageReceived.defaultMessageReceived)(message, channel, threadId));
  };
}